import {
    DatiqGraphAxisType,
    DatiqGraphType,
    DatiqGraphXYTypes,
    emptyDatiqGraph,
    emptyDatiqGraphAxisX,
    emptyDatiqGraphAxisY,
    IDatiqGraph,
} from '@dat/datiq-components-pkg/graph';
import {
    IDatiqGraphCardChart,
    IDatiqGraphCardChartData,
} from './datiq-graph-card-chart.interface';

export const emptyDatiqGraphCardChartData: IDatiqGraphCardChartData = {
    actual: [],
};

export const emptyDatiqGraphCardChart: IDatiqGraphCardChart = {
    current: 0,
    data: { ...emptyDatiqGraphCardChartData },
    useColor: true,
};

export const emptyDatiqGraphCardChartGraphAxisX = {
    ...emptyDatiqGraphAxisX,
    type: DatiqGraphAxisType.Number,
};
const emptyDatiqGraphCardChartGraphAxisY = {
    ...emptyDatiqGraphAxisY,
    type: DatiqGraphAxisType.Number,
};
export const emptyDatiqGraphCardChartGraph: IDatiqGraph = {
    ...emptyDatiqGraph,
    id: `lane-card-chart-${Math.random()
        .toString(36)
        .substring(3, 7)
        .toUpperCase()}`,

    series: [],
    type: DatiqGraphType.XYChart,
    xyType: DatiqGraphXYTypes.Miniature,
    xAxes: [emptyDatiqGraphCardChartGraphAxisX],
    yAxes: [emptyDatiqGraphCardChartGraphAxisY],
};
